import React from "react";

export default function SiteLoader() {
  return (
    <div className="min-h-screen bg-[#0c1729] flex items-center justify-center" data-testid="site-loader">
      <img src="/assets/hbhs-logo-clean-gold.png" alt="HBHS" className="w-64 opacity-70 animate-pulse" />
    </div>
  );
}
